<script setup>
import { studyRegions } from "@/utils/utils";
</script>

<template lang="pug">
w-dialog(:model-value="showModal" width="600px" @close="showModal = false")
    .my8.mx8(style="font-size:20px") This feature is for paid partners only. For more information, please see <a href="https://auo.org.au/partner/">Partnering with Us</a>.
    div(style="text-align:center")

      .button.px4.py2(style="margin:0 auto"
        @click.prevent="showModal = false"
        class="w-button w-button--primary w-button--large w-button--block"
      ) Close
w-tooltip
  template(#activator="{ on }")
    w-button#download-button.mr2(v-on="on" icon="mdi mdi-cloud-download" color="primary" bg-color="white" elevation="2" xl @click="clickOpen")
      | Download data
      w-icon.mdi-cloud-download
  | Download data
w-menu.csv-downloader(:model-value="menuOpen" custom overlay shadow @close="menuOpen=false" )

  .white--bg
    .pa2 Download CSV
    h5.px2.pt2
      | Choose study region
    w-list.white--bg(v-model="selectedRegion" :items="items" no-unselect)



</template>

<script>
import { getPerms, getApiBase, authHeaders } from "@/api";
async function download(downloadUrl) {
  // we need to first fetch it with auth headers, then create data URL to download.
  try {
    const response = await fetch(downloadUrl, {
      method: "GET",
      ...(await authHeaders()),
    });

    if (!response.ok) throw new Error("Download failed"); // TODO warn user

    const blob = await response.blob();
    const dataUri = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = dataUri;
    a.download = downloadUrl.split("/").pop();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch (error) {
    console.error("Download error:", error);
    // TODO warn user
  }
}
export default {
  props: ["boundaryType", "year"],
  data: () => ({
    menuOpen: false,
    selectedRegion: null,
    showModal: false,
    accessibleCities: null  // Will be 'all', an array, or null
  }),
  created() {
    window.CsvDownloader = this;
  },
  computed: {
    downloadName() {
      const downloadName = `${this.boundaryType.replace(
        /^([^_]+)/,
        "$1_download"
      )}`;
      return `${getApiBase()}/download/${downloadName}_${this.year}_${
        this.selectedRegion
      }.csv`;
    },
    items() {
      const items = Object.entries(studyRegions)
        .map(([k, v]) => {
          const isAccessible = this.isCityAccessible(k);
          return {
            label: v,
            value: k,
            disabled: !isAccessible
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label));
      if (this.boundaryType.match(/lga|ssc/)) {
        // "All" is only accessible if user has full access
        const allAccessible = this.accessibleCities === "all";
        items.unshift({
          label: "All study regions",
          value: "all",
          disabled: !allAccessible
        });
      }
      return items;
    },
  },
  methods: {
    async fetchAccessibleCities() {
      try {
        const headers = await authHeaders();
        const response = await fetch(`${getApiBase()}/accessible-cities`, {
          method: "GET",
          ...headers,
        });

        if (response.ok) {
          const data = await response.json();
          this.accessibleCities = data.accessibleCities;
        }
      } catch (error) {
        console.error("Error fetching accessible cities:", error);
        // Default to no access on error
        this.accessibleCities = [];
      }
    },
    isCityAccessible(cityKey) {
      // If still loading, assume not accessible
      if (this.accessibleCities === null) {
        return false;
      }
      // If user has full access
      if (this.accessibleCities === "all") {
        return true;
      }
      // Check if city is in the accessible list
      if (Array.isArray(this.accessibleCities)) {
        return this.accessibleCities.includes(cityKey);
      }
      // No access
      return false;
    },
    async clickOpen() {
      const perms = await getPerms();
      if (Object.entries(perms).find(([k, v]) => k.match(/_pro/) && v)) {
        // Fetch accessible cities when opening the menu (Auth0 is definitely ready now)
        if (this.accessibleCities === null) {
          await this.fetchAccessibleCities();
        }
        this.menuOpen = true;
      } else {
        await this.$nextTick();
        this.menuOpen = false;
        this.showModal = true;
      }
    },
  },
  watch: {
    async selectedRegion() {
      download(this.downloadName);
      this.menuOpen = true;
      await this.$nextTick();
      this.menuOpen = false;
    },
  },
};
</script>

<style>
.csv-downloader .w-list {
  max-height: 50vh;
  overflow-y: scroll;
}
</style>
